import React from 'react'
import { NavLink } from 'react-router-dom'
import { Card, Label } from 'semantic-ui-react'

const STATUS_COLORS = { draft: 'grey', issued: 'green', waived: 'blue', failed: 'red' }

export default function BillingRunsListItem ({ billingRun }) {
  const r = billingRun
  return (
    <Card>
      <Card.Content>
        <Card.Header>
          {r.periodStart} → {r.periodEnd}
        </Card.Header>
        <Card.Meta>
          <NavLink to={Routes.superuser_billing_subscription_path({ id: r.subscriptionId })}>
            subscription #{r.subscriptionId}
          </NavLink>
          {r.billingInvoiceId && (
            <> · <NavLink to={Routes.superuser_billing_invoice_path({ id: r.billingInvoiceId })}>
              invoice #{r.billingInvoiceId}
            </NavLink></>
          )}
        </Card.Meta>
        <Card.Description>
          <Label color={STATUS_COLORS[r.status] || 'grey'} size="mini">{r.status}</Label>
          {r.failureReason && <span style={{ color: 'red', marginLeft: 8 }}>{r.failureReason}</span>}
        </Card.Description>
        {r.usageSnapshot && (
          <pre style={{ fontSize: 11, marginTop: 8 }}>{JSON.stringify(r.usageSnapshot)}</pre>
        )}
      </Card.Content>
    </Card>
  )
}
